import { render, staticRenderFns } from "./PageBuilder.vue?vue&type=template&id=6236cc19&"
import script from "./PageBuilder.vue?vue&type=script&lang=ts&"
export * from "./PageBuilder.vue?vue&type=script&lang=ts&"
import style0 from "./PageBuilder.vue?vue&type=style&index=0&id=6236cc19&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports